import attributes from '../tracking/attributes';

class PaymentSectionAttributeReader {
  getPaymentMethodAttribute(paymentMethod, paymentMethodCategoryString = '') {
    return [
      attributes.getAttribute('paymentMethodName', this.convertName(paymentMethod)),
      attributes.getAttribute('paymentMethodCategory', paymentMethodCategoryString),
    ];
  }
  
  convertName(paymentMethod) {
    if (!isNaN(paymentMethod)) {
      return 'stored card';
    }
    if (paymentMethod.toLowerCase() === 'new_credit_card') {
      return 'new card';
    }
    return paymentMethod;
  }

  getV1Errors() {
    const errors = [];
    const v1ErrorBlocks = document.getElementsByClassName('error-block');
    Array.prototype.forEach.call(v1ErrorBlocks, (block) => {
      const tagName = block.tagName.toLowerCase();
      if (tagName == 'input' || tagName == 'select') {
        errors.push({fieldName: block.name, errorCode: 'error.general.validation'});
      }
    });
    return errors;
  }
}

export default new PaymentSectionAttributeReader();
